import {
  PlanCreateInterface,
  PlanInterface,
  PlanRepositoryInterface,
  PlanUpdateInterface,
} from '@/services/Plan/interfaces';
import { AxiosInstance } from 'axios';

export default class PlanRepository implements PlanRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAll(): Promise<PlanInterface[]> {
    const response = await this.axios.get('/system-user/plans');

    return response.data;
  }

  public async getOneById(id: number): Promise<PlanInterface> {
    const response = await this.axios.get(`/system-user/plans/${id}`);

    return response.data;
  }

  public async create(dto: PlanCreateInterface): Promise<PlanInterface> {
    const response = await this.axios.post(`/system-user/plans`, {
      ...dto,
      quota: Number(dto.quota),
      bandwidth: Number(dto.bandwidth),
      websiteCount: Number(dto.websiteCount),
    });

    return response.data;
  }

  public async update(id: number, dto: PlanUpdateInterface): Promise<PlanInterface> {
    const response = await this.axios.patch(`/system-user/plans/${id}`, {
      ...dto,
      quota: Number(dto.quota),
      bandwidth: dto.bandwidth ? Number(dto.bandwidth) : undefined,
      websitesCount: dto.websitesCount ? Number(dto.websitesCount) : undefined,
    });

    return response.data;
  }

  public async delete(id: number): Promise<void> {
    await this.axios.delete(`/system-user/plans/${id}`);
  }
}
